import React, { memo, useCallback, useMemo } from 'react'

import {
  Icon,
  Button,
  Quality as QualityIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import QualityContent from 'Pods/SearchPage/Shared/QualityContent/QualityContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearQualityContent } from 'Pods/SearchPage/Store/actions/qualityContent'
import { DEFAULT_STATE, QUALITY_LEVEL } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

const prefixIcon = <Icon notSpaced svgComponent={QualityIcon} color="dark" size="small" />

function Quality() {
  const translate = useTranslate()

  const quality = useSearchPageStore(state => state.quality)
  const contentSource = useSearchPageStore(state => state.contentSource)

  const hasSelectedAnyFilter = useMemo(() => {
    return quality[0] !== QUALITY_LEVEL.ANY || contentSource !== DEFAULT_STATE.contentSource
  }, [quality, contentSource])

  const handleReset = useCallback(() => {
    clearQualityContent()
  }, [])

  const content = useMemo(() => (
    <>
      <QualityContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter])

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.quality.title')}
      prefixIcon={prefixIcon}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Quality)
